import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { AppSettings } from "../../proyect.conf";
import { AutenticacionService } from './autenticacion.service';
import {PoliticaPerfil} from '../_models/politica-perfil';
import {PoliticaModalidad} from '../_models/politica-modalidad';

@Injectable({
  providedIn: "root",
})
export class PoliticasModalidadService {
  private rutServicio = AppSettings.rutServiciosPOLITICA + "/api/politicasModalidades";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listadoPoliticaPerfil() {
    return this.httpClient
      .get(this.rutServicio)
      .pipe(map((res) => res as PoliticaModalidad[]));
  }

  listadoPoliticaPerfilHabilitados() {
    return this.httpClient
      .get(this.rutServicio + "/enabled")
      .pipe(map((res) => res as PoliticaModalidad[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicio + "/" + id)
      .pipe(map((res) => res as PoliticaModalidad));
  }

  listadoIdPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaModalidad[]));
  }

  listadoIdPoliticaEnabled(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicio  + "/politica/" + idPolitica + "/enabled" )
      .pipe(map((res) => res as PoliticaModalidad[]));
  }

  listadoIdModalidad(idModalidadCredito: string) {
    return this.httpClient
      .get(this.rutServicio  + "/modalidad/" + idModalidadCredito)
      .pipe(map((res) => res as PoliticaModalidad[]));
  }

  listadoIdModalidadEnabled(idModalidadCredito: string) {
    return this.httpClient
      .get(this.rutServicio  + "/modalidad/" + idModalidadCredito + "/enabled" )
      .pipe(map((res) => res as PoliticaModalidad[]));
  }

  crear(regCrear: PoliticaPerfil) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicio, regCrear)
      .pipe(map((res) => res as PoliticaModalidad));
  }

  actualizar(regActualizar: PoliticaPerfil) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicio, regActualizar)
      .pipe(map((res) => res as PoliticaModalidad));
  }

  bulk(registros: PoliticaModalidad[]) {
    registros.map((s: PoliticaModalidad) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient
      .post(this.rutServicio + "/bulk", registros)
      .pipe(map((res) => res as PoliticaModalidad[]));
  }
}
